define( [
	"../var/class2type",
	"../var/toString"
], function( class2type, toString ) {

"use strict";

function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}

return toType;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/core/toType.js
// module id = 39
// module chunks = 0